// extracted by mini-css-extract-plugin
export const card = "achievement-card-module--card--2lSiG";
export const image = "achievement-card-module--image--1au68";
export const content = "achievement-card-module--content--2Rd_r";